const URL = {

  INTRODUCTION : `${ process.env.PUBLIC_URL }/introduction`,
  SELECT_LEARNING : `${ process.env.PUBLIC_URL }/selectLearning`,
  PM_INFO: `${process.env.REACT_APP_RESOURCE_URL}/brs/pm/pminfo_mathpid.xml`,
  PM_INFO_EN: `${process.env.REACT_APP_RESOURCE_URL}/brs/pm/pminfo_mathpid_EN.xml`,
  STAR_SHOP_HISTORY: `${ process.env.PUBLIC_URL }/starshophistory`,
  HELP: '/help',
  ACCOUNT: {
    LOGIN: '/login',
    LEAVE: '/leave',
    LEAVE_SUCCESS: '/leavesuccess',
    ID_INQUIRY: '/idInquiry',
    PW_INQUIRY: '/pwInquiry',
    PW_INQUIRY_SUCCESS: '/pwInquirysuccess',
    MY_PAGE: '/mypage',
    GM_MEMBER_AUTH: '/memberauth',
    GM_MEMBER_AUTH_SUCCESS: '/memberauthsuccess',
    LEARNER_CHOICE: '/learnerchoice',
    JOIN: {
      I: '/join',
      SUCCESS: '/join/success'
    },
    POLICY: {
      I: '/policy',
      TERMS: '/policy/terms',
      PRIVACY: '/policy/privacy',
      MARKETING: '/policy/marketing',
    },
    APP_ID_SIGN: `${process.env.PUBLIC_URL}/account/appIdSign`,
    APP_ID_SIGN_SUCCESS: `${process.env.PUBLIC_URL}/account/appidsignsuccess`
  },
  
  COURSE_LEARNING : {
    I : `${ process.env.PUBLIC_URL }/courseLearning`,
    AI_DIAGNOSIS_TEST : {
      I : `${ process.env.PUBLIC_URL }/courseLearning/aiDiagnosisTest`,
      DIAGNOSIS_GUIDE1 : `${ process.env.PUBLIC_URL }/courseLearning/aiDiagnosisTest/diagnosisGuide1`,
      DIAGNOSIS_GUIDE2 : `${ process.env.PUBLIC_URL }/courseLearning/aiDiagnosisTest/diagnosisGuide2`,
      DIAGNOSIS_GUIDE3 : `${ process.env.PUBLIC_URL }/courseLearning/aiDiagnosisTest/diagnosisGuide3`,
      GUIDE1 : `${ process.env.PUBLIC_URL }/courseLearning/aiDiagnosisTest/guide1`,
      GUIDE2 : `${ process.env.PUBLIC_URL }/courseLearning/aiDiagnosisTest/guide2`,
      NOTICE : `${ process.env.PUBLIC_URL }/courseLearning/aiDiagnosisTest/notice`,
      ENTER_LEARNER_DATA : `${ process.env.PUBLIC_URL }/courseLearning/aiDiagnosisTest/enterLearnerData`,
      AI_PREDICTION : `${ process.env.PUBLIC_URL }/courseLearning/aiDiagnosisTest/aiPrediction`,
      ANSWERING_QUESTIONS : `${ process.env.PUBLIC_URL }/courseLearning/aiDiagnosisTest/answeringQuestions`,
      ANALYSIS : `${ process.env.PUBLIC_URL }/courseLearning/aiDiagnosisTest/analysis`,
      RESULT : `${ process.env.PUBLIC_URL }/courseLearning/aiDiagnosisTest/result`
    },
    GUIDE : `${ process.env.PUBLIC_URL }/courseLearning/guide`,
    LIST : `${ process.env.PUBLIC_URL }/courseLearning/list`,
    LEARNING_NOTE : `${ process.env.PUBLIC_URL }/courseLearning/learningNote`,
    COMPLETE_LOADING: `${process.env.PUBLIC_URL}/courseLearning/completeLoading`,
  },

  TOPIC_LEARNING: `${ process.env.PUBLIC_URL }/topicLearning`,

  PROGRESS_LEARNING: {
    I: `${ process.env.PUBLIC_URL }/progressLearing`,
    AI_BAROSEM: `${ process.env.PUBLIC_URL }/progressLearing/aibarosem`,
    MATHEMATICS: `${ process.env.PUBLIC_URL }/progressLearing/mathematics`
  },

  TUTORIAL : `${ process.env.PUBLIC_URL }/tutorial`,

  LEARNING : {
    I : `${ process.env.PUBLIC_URL }/learning`,
    ANSWERING_QUESTIONS : `${ process.env.PUBLIC_URL }/learning/answeringQuestions`,
    RESULT : `${ process.env.PUBLIC_URL }/learning/result`,
    CHECK_WRONG_ANSWER : `${ process.env.PUBLIC_URL }/learning/checkWrongAnswer`,
    RE_ANSWERING : `${ process.env.PUBLIC_URL }/learning/reAnswering`
  },

  QUESTION_INSPECTION : {
    I : `${ process.env.PUBLIC_URL }/questionInspection`,
    LIST : `${ process.env.PUBLIC_URL }/questionInspection/list`,
    AI_PREDICTION : `${ process.env.PUBLIC_URL }/questionInspection/aiPrediction`,
    ANSWERING_QUESTIONS : `${ process.env.PUBLIC_URL }/questionInspection/answeringQuestions`
  },

  OCR: {
    I: `${process.env.PUBLIC_URL}/ocr`,
    HISTORY: `${process.env.PUBLIC_URL}/ocr/history`,
    USAGE: `${process.env.PUBLIC_URL}/ocr/usage`,
    RECOMMEND_LEARNING: `${process.env.PUBLIC_URL}/ocr/rcmndlearning`,
  },

  PAYMENT : {
    SUBSCRIBE : `${process.env.PUBLIC_URL}/payment/subscribe`,
    BEFORE : `${process.env.PUBLIC_URL}/payment/before`,
    SUBSCRIBE_NEW : `${process.env.PUBLIC_URL}/payment/subscribeNew`,
  },

  ERROR: {
    PAGE: `${ process.env.PUBLIC_URL }/error404`,
  },

  IFRAME : {
    I : `${ process.env.PUBLIC_URL }/iframe`,
    CHECK_CONCEPT : `${ process.env.PUBLIC_URL }/iframe/checkConcept`,
    CHECK_WRONG_ANSWER : `${ process.env.PUBLIC_URL }/iframe/checkWrongAnswer`,
    OCR_MATHPIX : `${ process.env.PUBLIC_URL }/iframe/ocrmathpix`
  },

  SAMPLE: `${ process.env.PUBLIC_URL }/sample`,
  WORK_SHEET: `${ process.env.PUBLIC_URL}/worksheet`,
  LEAVE: {
    GOOGLE_LEVEL: `${ process.env.PUBLIC_URL }/withdrawal`,
    SUCCESS: `${ process.env.PUBLIC_URL }/leaveSuccess`
  },

  API : {
    CODE: `${process.env.REACT_APP_API_URL}/api/code`,
    WPIN_DE: `${process.env.REACT_APP_API_URL}/api/wpin/de`,
    LOGIN : `${ process.env.REACT_APP_API_URL }/api/members/signin`,
    PAD_LOGIN : `${ process.env.REACT_APP_API_URL }/api/mbrsp/login`,
    MEMBERS : {
      MEMBERS : `${ process.env.REACT_APP_API_URL }/api/members`,
      LOG : `${ process.env.REACT_APP_API_URL }/api/log/members`
    },
    DIAGNOSIS : {
      PROPOSAL : `${ process.env.REACT_APP_API_URL }/api/diagnosis/proposal`,
      PROGRESS : `${ process.env.REACT_APP_API_URL }/api/diagnosis/progress`,
      INFO : `${ process.env.REACT_APP_API_URL }/api/diagnosis/info`,
      CONFIRM : `${ process.env.REACT_APP_API_URL }/api/diagnosis/confirm`
    },
    COURSE_LEARNING : {
      NOTE : `${ process.env.REACT_APP_API_URL }/api/learning/note/user`,
      ANALYSIS : `${ process.env.REACT_APP_API_URL }/api/learning/note/user/analysis`
    },
    LEARNING : {
      I: `${ process.env.REACT_APP_API_URL }/api/learning`,
      LEARNING_HISTORY: `${ process.env.REACT_APP_API_URL }/api/learning/note/user/thema`,
      NOTE: {
        RESULT : `${ process.env.REACT_APP_API_URL }/api/learning/note/user/diagnosis/result`
      },
      COMMON : {
        I : `${ process.env.REACT_APP_API_URL }/api/learning/common`,
        CRANSR : {
          CHECK : `${ process.env.REACT_APP_API_URL }/api/learning/common/cransr/check`
        },
        STUDY : `${ process.env.REACT_APP_API_URL }/api/learning/common/study`,
        RESULT : `${ process.env.REACT_APP_API_URL }/api/learning/common/result`,
        WRANSR : `${ process.env.REACT_APP_API_URL }/api/learning/common/wransr`
      },
      THEMA : `${ process.env.REACT_APP_API_URL }/api/learning/thema`,
      RESULT : `${ process.env.REACT_APP_API_URL }/api/learning/common/result`,
      COURSE : `${ process.env.REACT_APP_API_URL }/api/learning/course`,
      HISTORY : `${ process.env.REACT_APP_API_URL }/api/learning/history`,
      RESUME : `${ process.env.REACT_APP_API_URL }/api/learning/mathpid/course/resume`
    },
    QSTISP : {
      I : `${ process.env.REACT_APP_API_URL }/api/qstisp`,
      STAGE : `${ process.env.REACT_APP_API_URL }/api/qstisp/stage`,
      CODE : {
        LANGUAGE : `${ process.env.REACT_APP_API_URL }/api/qstisp/code/language`
      },
      CRANSR : {
        CHECK : `${ process.env.REACT_APP_API_URL }/api/qstisp/cransr/check`
      }
    },
    PROGRESS_LEARNING: {
      I: `${ process.env.REACT_APP_API_URL }/api/learning/brs`,
      BRS_STEP_CODE_SEL: `${ process.env.REACT_APP_API_URL }/api/learning/brs/step`,
      BRS_HO_CODE_SEL: `${ process.env.REACT_APP_API_URL }/api/learning/brs/edition/step`,
      BRS_UNIT_CODE_SEL: `${ process.env.REACT_APP_API_URL }/api/learning/brs/unit/curs`
    },
    SELVAS : `${ process.env.REACT_APP_NOTES_API_URL }/selvas`,
    TTS : `${ process.env.REACT_APP_TTS_URL }/tts`,
    GM: {
      I: `${process.env.REACT_APP_API_URL}/api/mbrgm`,
      AUTO_LOGIN: `${process.env.REACT_APP_API_URL}/api/mbrgm/autoLogin`,
      AUTO_LOGIN_REG: `${process.env.REACT_APP_API_URL}/api/mbrgm/appAutoLogin`,
      MEMBERS: `${process.env.REACT_APP_API_URL}/api/members`,
      EMAIL_VERIFY: `${process.env.REACT_APP_API_URL}/api/members/email/verify`,
      PW_INQUIRY: `${process.env.REACT_APP_API_URL}/api/members/email/pw`,
      PAD_LOGIN: `${ process.env.REACT_APP_API_URL }/api/mbrgm/bookpadLogin`,
      EMAIL_LOGIN: `${process.env.REACT_APP_API_URL}/api/mbrgm/appLogin`,
      EMAIL_SEND: `${process.env.REACT_APP_API_URL}/api/members/email/send`,
      CP_LOGIN: `${process.env.REACT_APP_API_URL}/api/mbrgm/bookpadCpLogin`,
      GOOGLE_LEAVE: `${process.env.REACT_APP_API_URL}/api/members/revoke/email`,
    },
    OCR: {
      I: `${process.env.REACT_APP_API_URL}/api/ocr`,
      STAGE: `${process.env.REACT_APP_API_URL}/api/ocr/stage`,
      HISTORY: `${process.env.REACT_APP_API_URL}/api/ocr/history`,
      DETAIL: `${process.env.REACT_APP_OCR_API_URL}/api/v1/upload_history`,
      AIBAROSAM_DETAIL: `${process.env.REACT_APP_OCR_API_URL}/api/v2/upload_history`,
    },
    STAR_SHOP: {
      I: `${process.env.REACT_APP_API_URL}/reward/v2.0`,
      V3: `${process.env.REACT_APP_API_URL}/reward/v3.0`,
      AUTH: `${process.env.REACT_APP_API_URL}/tas/v1.0/cert/token`
    },
    KINESIS : {
      XAPI : `${ process.env.REACT_APP_API_URL }/api/kinesis/xapi`,
      // XAPI : `${ process.env.REACT_APP_API_URL }/api/kinesis/xapi`,
      WRITTEN : `${ process.env.REACT_APP_API_URL }/api/kinesis/written`,
      PKGINFO : `${ process.env.REACT_APP_API_URL }/api/kinesis/pkginfo`
    },
    LOG: `${ process.env.REACT_APP_API_URL }/api/fo/log`,
    GLOBAL: {
      MAIN: `${process.env.REACT_APP_API_URL}/api/main`,
      LOGIN: `${process.env.REACT_APP_API_URL}/api/members/signin`,
      AUTO_LOGIN: `${process.env.REACT_APP_API_URL}/api/members/auto`,
      SIGNUP: `${process.env.REACT_APP_API_URL}/api/members`,
      GUEST_SEL_REG: `${process.env.REACT_APP_API_URL}/api/guest/info`,
      GUEST_JOIN: `${process.env.REACT_APP_API_URL}/api/guest/members`,
      WORK_SHEET: `${process.env.REACT_APP_API_URL}/api/learning/worksheet/setting`,
      QR_WORK_SHEET: `${process.env.REACT_APP_API_URL}/api/learning/worksheet/qrInfo`,
      WORK_SHEET_EMAI_SEND: `${process.env.REACT_APP_API_URL}/api/learning/worksheet/send`
    },
    GEO_IP : `${process.env.REACT_APP_API_URL}/api/geoip`
  }

};

export default URL;
